import { ReactComponent as FacebookIcon } from '../images/social-icons/facebook.svg';
import { ReactComponent as TwitterIcon } from '../images/social-icons/twitter.svg';
import { ReactComponent as VkontakteIcon } from '../images/social-icons/vkontakte.svg';
import { ReactComponent as SnapchatIcon } from '../images/social-icons/snapchat.svg';
import { ReactComponent as LinkedinIcon } from '../images/social-icons/linkedin.svg';
import { ReactComponent as WhatsappIcon } from '../images/social-icons/whatsapp.svg';
import { ReactComponent as GoogleIcon } from '../images/social-icons/google.svg';
import { ReactComponent as TelegramIcon } from '../images/social-icons/telegram.svg';
import { ReactComponent as InstagramIcon } from '../images/social-icons/instagram.svg';
import { ReactComponent as MyspaceIcon } from '../images/social-icons/myspace.svg';
import { ReactComponent as WikipediaIcon } from '../images/social-icons/wikipedia.svg';
import { ReactComponent as TrueCallerIcon } from '../images/social-icons/truecaller.svg';
import { ReactComponent as XingIcon } from '../images/social-icons/xing.svg';
import { ReactComponent as PinterestIcon } from '../images/social-icons/pinterest.svg';
import { ReactComponent as YoutubeIcon } from '../images/social-icons/youtube.svg';
import { ReactComponent as TwitchIcon } from '../images/social-icons/twitch.svg';
import { ReactComponent as CashAppIcon } from '../images/social-icons/cashapp.svg';
import { ReactComponent as ShowCallerIcon } from '../images/social-icons/showcaller.svg';
import { ReactComponent as SpotifyIcon } from '../images/social-icons/spotify.svg';
import { ReactComponent as QuoraIcon } from '../images/social-icons/quora.svg';
import { ReactComponent as AppleIcon } from '../images/social-icons/apple.svg';
import { ReactComponent as EventBriteIcon } from '../images/social-icons/eventbrite.svg';
import { ReactComponent as ThatsThemIcon } from '../images/social-icons/thatsthem.svg';
import { ReactComponent as NameIcon } from 'src/common/images/name.svg';
import { ReactComponent as EmailIcon } from 'src/common/images/email.svg';
import { ReactComponent as PhoneIcon } from 'src/common/images/phone.svg';

import { IconAngry, IconEmpathy, IconHaha, IconLike, IconLove, IconSad, IconWow } from '../images';
export const SECOND_IN_MILLI = 1000;
export const MINUTE_IN_MILLI = SECOND_IN_MILLI * 60;

const constants = {
    AXIOS_TIMEOUT: parseInt(process.env.REACT_APP_AXIOS_TIMEOUT_IN_SECONDS) * SECOND_IN_MILLI,
    IMAGE_RETRY_ATTEMPT_AMOUNT: parseInt(process.env.REACT_APP_IMAGE_RETRY_ATTEMPT_AMOUNT),
    IMAGE_RETRY_ATTEMPT_INTERVAL_IN_SECONDS:
        parseInt(process.env.REACT_APP_IMAGE_RETRY_ATTEMPT_INTERVAL_IN_SECONDS) * SECOND_IN_MILLI,
    WORKSPACES_POLLING_DELAY: parseInt(process.env.REACT_APP_WORKSPACES_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    CASES_POLLING_DELAY: parseInt(process.env.REACT_APP_CASES_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    MORE_RESULTS_POLLING_DELAY: parseInt(process.env.REACT_APP_MORE_RESULTS_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    COLLECTIONS_POLLING_DELAY: parseInt(process.env.REACT_APP_COLLECTIONS_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    STREAMS_POLLING_DELAY: parseInt(process.env.REACT_APP_STREAMS_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    REPORT_POLLING_DELAY: parseInt(process.env.REACT_APP_REPORT_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    POSSIBLE_MATCHES_POLLING_DELAY:
        parseInt(process.env.REACT_APP_POSSIBLE_MATCHES_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    NOTIFICATIONS_POLLING_DELAY: parseInt(process.env.REACT_APP_NOTIFICATIONS_POLLING_IN_SECONDS) * SECOND_IN_MILLI,
    EMPTY_INPUT: '',
    STATUS_200: 200,
    STATUS_300: 300,
};
export const PLATFORM_APP = process.env.REACT_APP_PLATFORM?.toLowerCase() === 'true';
export const SRC_PREFIX = '/api/osint';
export const REQUEST = {
    METHOD: {
        GET: 'get',
        POST: 'post',
        PUT: 'put',
        DELETE: 'delete',
    },
};

export const SECTION = {
    SUMMARY: 'summary',
    INSIGHTS: 'insights',
    PERSONAL_INFO: 'personalInfo',
    SOCIAL_PRESENCE: 'socialPresence',
    CONNECTIONS: 'connections',
    MEDIA: 'media',
    LOCATIONS: 'locations',
    POSTS: 'posts',
    WEB_MENTIONS: 'webMentions',
};

export const LOADER = {
    STATUS: {
        LOADING: 'loading',
        LOADED: 'loaded',
        FAILED: 'failed',
        DISABLED: 'disabled',
    },
};
export const SORT = {
    DIRECTION: {
        DESC: 'DESC',
        ASC: 'ASC',
    },
};

export const MAPPED_NAME_TYPES = {
    name: 'Name',
    phone: 'Phone',
    email: 'Email',
    search_pointer: 'PIPL',
    lex_id: 'LexisNexis',
    lexis_nexis_id: 'LexisNexis',
    cpf: 'CPF',
    facebook_id: 'Facebook ID',
    twitter_id: 'Twitter ID',
    linkedin_id: 'LinkedIn ID',
    instagram_id: 'Instagram ID',
    pinterest_id: 'Pinterest ID',
    tiktok_id: 'TikTok ID',
    vkontakte_id: 'VKontakte ID',
    snapchat_id: 'Snapchat ID',
    xing_id: 'Xing ID',
    youtube_id: 'YouTube ID',
    cashapp_id: 'CashApp ID',
    twitch_id: 'Twitch ID',
    general_username: 'Username',
    thatsthem_id: 'ThatsThem ID',
};

export const ANALYSIS_TYPE = {
    FULL: 'FullAnalysis',
    SOCIAL: 'SocialAnalysis',
    LOOKUP: 'Lookup',
};

export const STATUS = {
    COMPLETE: 'Complete',
    IN_PROGRESS: 'In Progress',
};

export const PLATFORM = {
    FACEBOOK: 'Facebook',
    TWITTER: 'Twitter',
    INSTAGRAM: 'Instagram',
    LINKEDIN: 'LinkedIn',
    PINTEREST: 'Pinterest',
    TIKTOK: 'TikTok',
    VKONTAKTE: 'VKontakte',
    SNAPCHAT: 'Snapchat',
    XING: 'Xing',
    YOUTUBE: 'YouTube',
    TWITCH: 'Twitch',
    CASHAPP: 'CashApp',
    SPOTIFY: 'Spotify',
    QUORA: 'Quora',
    EVENTBRITE: 'EventBrite',
    APPLE: 'Apple',
    THATSTHEM: 'ThatsThem',
};

export const SEARCH_TYPE = {
    BY_ALL: 'general_username',
    BY_EMAIL_ADDRESS: 'ByEmailAddress',
    BY_PHONE_NUMBER: 'ByPhoneNumber',
    BY_CPF: 'ByCpf',
    BY_FACEBOOK_ID: 'ByFid',
    BY_INSTAGRAM_ID: 'ByIid',
    BY_TWITTER_ID: 'ByTid',
    BY_LINKEDIN_ID: 'ByLid',
    BY_PINTEREST_ID: 'pinterest_id',
    BY_TIKTOK_ID: 'tiktok_id',
    BY_VKONTAKTE_ID: 'vkontakte_id',
    BY_SNAPCHAT_ID: 'snapchat_id',
    BY_LEXISNEXIS_ID: 'lex_id',
    BY_PIPL_ID: 'pipl_id',
    BY_THATSTHEM_ID: 'thatsthem_id',
    BY_SEARCH_POINTER: 'ByPiplSearchPointer',
    BY_NAME: 'ByName',
    BY_IDN: 'ByIdn',
    BY_SOCIAL_ID: 'socialID',
    BY_XING_ID: 'xing_id',
    BY_YOUTUBE_ID: 'youtube_id',
    BY_TWITCH_ID: 'twitch_id',
    BY_CASHAPP_ID: 'cashapp_id',
};

export const SEARCH_TYPE_FILTER_OPTIONS = [
    SEARCH_TYPE.BY_ALL,
    SEARCH_TYPE.BY_PHONE_NUMBER,
    SEARCH_TYPE.BY_EMAIL_ADDRESS,
    SEARCH_TYPE.BY_NAME,
    SEARCH_TYPE.BY_FACEBOOK_ID,
    SEARCH_TYPE.BY_INSTAGRAM_ID,
    SEARCH_TYPE.BY_TWITTER_ID,
    SEARCH_TYPE.BY_LINKEDIN_ID,
    SEARCH_TYPE.BY_PINTEREST_ID,
    SEARCH_TYPE.BY_TIKTOK_ID,
    SEARCH_TYPE.BY_VKONTAKTE_ID,
    SEARCH_TYPE.BY_SNAPCHAT_ID,
    SEARCH_TYPE.BY_XING_ID,
    SEARCH_TYPE.BY_SEARCH_POINTER,
    SEARCH_TYPE.BY_YOUTUBE_ID,
];

export const FILTER = {
    TABLE_OPTIONS: 'invert(45%) sepia(14%) saturate(515%) hue-rotate(166deg) brightness(93%) contrast(90%)',
};

export const socialPlatformsMap = new Map([
    ['Facebook', SEARCH_TYPE.BY_FACEBOOK_ID],
    ['Twitter', SEARCH_TYPE.BY_TWITTER_ID],
    ['Instagram', SEARCH_TYPE.BY_INSTAGRAM_ID],
    ['Linkedin', SEARCH_TYPE.BY_LINKEDIN_ID],
    ['Pinterest', SEARCH_TYPE.BY_PINTEREST_ID],
    ['Tiktok', SEARCH_TYPE.BY_TIKTOK_ID],
    ['Vkontakte', SEARCH_TYPE.BY_VKONTAKTE_ID],
    ['Pipl', SEARCH_TYPE.BY_PIPL_ID],
    ['Lexisnexis', SEARCH_TYPE.BY_LEXISNEXIS_ID],
    ['Snapchat', SEARCH_TYPE.BY_SNAPCHAT_ID],
    ['Xing', SEARCH_TYPE.BY_XING_ID],
    ['Youtube', SEARCH_TYPE.BY_YOUTUBE_ID],
    ['Cashapp', SEARCH_TYPE.BY_CASHAPP_ID],
    ['Twitch', SEARCH_TYPE.BY_TWITCH_ID],
]);

export const MAP_PLATFORM_TO_SEARCH_TYPE = {
    pipl: SEARCH_TYPE.BY_PIPL_ID,
    thatsthem: SEARCH_TYPE.BY_THATSTHEM_ID,
    lexisnexis: SEARCH_TYPE.BY_LEXISNEXIS_ID,
    facebook: SEARCH_TYPE.BY_FACEBOOK_ID,
    twitter: SEARCH_TYPE.BY_TWITTER_ID,
    linkedin: SEARCH_TYPE.BY_LINKEDIN_ID,
    instagram: SEARCH_TYPE.BY_INSTAGRAM_ID,
    pinterest: SEARCH_TYPE.BY_PINTEREST_ID,
    vkontakte: SEARCH_TYPE.BY_VKONTAKTE_ID,
    xing: SEARCH_TYPE.BY_XING_ID,
    tiktok: SEARCH_TYPE.BY_TIKTOK_ID,
    snapchat: SEARCH_TYPE.BY_SNAPCHAT_ID,
    twitch: SEARCH_TYPE.BY_TWITCH_ID,
    cashapp: SEARCH_TYPE.BY_CASHAPP_ID,
    youtube: SEARCH_TYPE.BY_YOUTUBE_ID,
};

export const COLORS = {
    BRAND_DARK: '#121E28',
    BRAND_ACTIVE: '#0152A6',
    BRAND: '#0064CC',
    BRAND_HOVER: '#3383D6',
    BRAND_LIGHT: '#D1E4F9',
    BRAND_LIGHTEST: '#E8F2FF',
    MUTED_HEAVY: '#1E2C3F',
    MUTED_DARK: '#5E6974',
    MUTED_SHADY: '#8E9EAE',
    MUTED_LIGHT: '#ADB9BF',
    MUTED_LIGHTEST: '#BDC3C8',
    MUTED_HOVER: '#E7ECF1',
    MUTED_SOFT: '#F1F4F6',
    MUTED_DOUBLE_HOVER: '#CCD4DD99',
    WARNING_LIGHTEST: '#FFAE09',
    POSITIVE: '#458922',
    NEGATIVE: '#D30813',
    POSITIVE_LIGHTEST: '#ECF7F0',
    LIGHT: '#FFF',
    WARNING_SOFT: '#FFECB2',
    NEGATIVE_HEAVY: '#A7081E',
};

export const FILTER_COLORS = {
    MUTED_DARK:
        'brightness(0) saturate(100%) invert(42%) sepia(11%) saturate(600%) hue-rotate(169deg) brightness(90%) contrast(82%)',
};

export const DEFAULT_CHART_COLORS = [
    '#44AF69',
    COLORS.WARNING_LIGHTEST,
    '#2A85E2',
    '#9B7EEF',
    '#7FDBDB',
    '#EC8BB3',
    '#D03639',
    '#DBC17F',
    '#56626C',
];
export default constants;

export const socialPlatformsUserFriendlyDisplayName = new Map([
    ['FACEBOOK', 'Facebook'],
    ['GOOGLE_PLUS', 'Google'],
    ['GOOGLE', 'Google'],
    ['INSTAGRAM', 'Instagram'],
    ['MYSPACE', 'Myspace'],
    ['TWITTER', 'Twitter'],
    ['VK', 'VKontakte'],
    ['WIKIPEDIA', 'Wikipedia'],
    ['LINKEDIN', 'LinkedIn'],
    ['WHATSAPP', 'WhatsApp'],
    ['TELEGRAM', 'Telegram'],
    ['TIKTOK', 'TikTok'],
    ['SNAPCHAT', 'Snapchat'],
    ['PINTEREST', 'Pinterest'],
    ['XING', 'Xing'],
    ['TRUECALLER', 'TrueCaller'],
    ['DUCKDUCKGO', 'DuckDuckGo'],
    ['GETCONTACT', 'GetContact'],
    ['CALLAPP', 'CallApp'],
    ['DRUPE', 'drupe'],
    ['YOUTUBE', 'YouTube'],
    ['WORDPRESS', 'WordPress'],
    ['TWITCH', 'Twitch'],
    ['CASHAPP', 'CashApp'],
    ['SHOWCALLER', 'showcaller'],
    ['SPOTIFY', 'Spotify'],
    ['QUORA', 'Quora'],
    ['EVENTBRITE', 'EventBrite'],
    ['APPLE', 'Apple'],
    ['THATSTHEM', 'ThatsThem'],
]);

export const socialPlatformIcons = new Map([
    ['FACEBOOK', FacebookIcon],
    ['GOOGLE_PLUS', GoogleIcon],
    ['INSTAGRAM', InstagramIcon],
    ['MYSPACE', MyspaceIcon],
    ['TWITTER', TwitterIcon],
    ['VK', VkontakteIcon],
    ['SNAPCHAT', SnapchatIcon],
    ['WIKIPEDIA', WikipediaIcon],
    ['LINKEDIN', LinkedinIcon],
    ['WHATSAPP', WhatsappIcon],
    ['TELEGRAM', TelegramIcon],
    ['TRUECALLER', TrueCallerIcon],
    ['XING', XingIcon],
    ['PINTEREST', PinterestIcon],
    ['YOUTUBE', YoutubeIcon],
    ['SHOWCALLER', ShowCallerIcon],
    ['Twitch', TwitchIcon],
    ['CashApp', CashAppIcon],
    ['Spotify', SpotifyIcon],
    ['Quora', QuoraIcon],
    ['EventBrite', EventBriteIcon],
    ['Apple', AppleIcon],
    ['THATSTHEM', ThatsThemIcon],
]);

export const searchTypesIcons = new Map([
    ['NAME', NameIcon],
    ['EMAIL', EmailIcon],
    ['PHONE', PhoneIcon],
]);

export const defaultPreferences = {
    searchReasons: [
        {
            label: 'No Justification Provided',
            description: '',
            default: true,
            comment: '',
        },
        {
            label: 'Criminal Nexus',
            description: '',
            default: true,
            comment: '',
        },
        {
            label: 'Situational Awareness',
            description: '',
            default: true,
            comment: '',
        },
        {
            label: 'Threat Assessment',
            description: '',
            default: true,
            comment: '',
        },
        {
            label: 'Vulnerability Assessment',
            description: '',
            default: true,
            comment: '',
        },
        {
            label: 'Employee Background Check',
            description: '',
            default: true,
            comment: '',
        },
    ],
    error: true,
};

export const connectionTags = {
    'FOLLOWER OF': 'Follower',
    'FOLLOWER': 'Follower',
    'FOLLOWING': 'Following',
    'FOLLOWINGS': 'Followings',
    'FOLLOWERS': 'Followers',
    'TAGGED': 'Tagged',
    'TAGGED BY': 'Tagged By',
    'LIKER': 'Likes',
    'LIKERS': 'Likes',
    'SHARER': 'Shares',
    'SHARERS': 'Shares',
    'FRIEND': 'Friend',
    'FRIENDS': 'Friends',
    'RECOMMENDED': 'Recommended',
    'RECOMMENDER': 'Recommender',
    'ENDORSER': 'Endorsements',
    'ENDORSERS': 'Endorsements',
    'COMMENTER': 'Comments',
    'COMMENTERS': 'Comments',
    'REACTED': 'Reactions',
};

export const connectionsCountsTypesInterpolation = {
    FOLLOWERS: 'Followers',
    FOLLOWING: 'Following',
    FRIENDS: 'Friends',
    LIKER: 'Likers',
    SHARER: 'Sharers',
    ENDORSER: 'Endorsers',
    CONNECTIONS: 'Connections',
    COMMENTERS: 'Commenters',
    REACTED: 'Reacted',
    TAGGED: 'Tagged',
    TAGGEDBY: 'Tagged By',
};

export const reactionIcons = {
    like: IconLike,
    love: IconLove,
    haha: IconHaha,
    wow: IconWow,
    sad: IconSad,
    angry: IconAngry,
    empathy: IconEmpathy,
};

export const DEFAULT_TAGS = {
    'Evidence': '#FFBC31',
    'Important': '#D43B29',
    'Not Relevant': COLORS.MUTED_SHADY,
};

export const TAG_COLORS = [
    '#FFBC31',
    '#D43B29',
    COLORS.MUTED_SHADY,
    '#9B7EEF',
    '#E97BA9',
    '#F39C6B',
    '#EC1A7F',
    '#C5E99B',
    '#7FDBDB',
    '#44AF69',
    '#DBC17F',
    '#CE8FFF',
    '#5B869F',
    '#DD6E4C',
    '#2117CD',
    '#98A886',
    '#CA884C',
    '#9ACAE7',
    '#EDAEF8',
    '#CEE34D',
    '#BF98A0',
    '#90E39A',
    '#FFC99C',
];

export const CHART_COLORS = {
    DEFAULT: [
        '#44AF69',
        '#FFAE09',
        '#2A85E2',
        '#9B7EEF',
        '#7FDBDB',
        '#56626C',
        '#E97BA9',
        '#C5E99B',
        '#DBC17F',
        '#5B869F',
        '#DD6E4C',
        '#98A886',
        '#CA884C',
        '#9ACAE7',
        '#FF891A',
        '#A7081E',
    ],
    BLUR: [
        '#CBF5C8',
        '#FFECB2',
        '#AACEF3',
        '#D7CBF9',
        '#D7FBFB',
        '#D4D2D2',
        '#F6CADD',
        '#E8F6D7',
        '#F1E6CC',
        '#BDCFD9',
        '#F1C5B8',
        '#D6DCCF',
        '#F0C7A1',
        '#D7EAF5',
        '#FFECB2',
        '#FAC5C5',
    ],
};

export const MAPPED_TOPICS = {
    'Money': {
        NAME: 'Money',
        COLOR: '#F7B71B',
    },
    'School': {
        NAME: 'School',
        COLOR: '#EF4F54',
    },
    'Family': {
        NAME: 'Family',
        COLOR: '#3D86FB',
    },
    'Drugs': {
        NAME: 'Drugs',
        COLOR: '#A4B51E',
    },
    'Social Media': {
        NAME: 'Social Media',
        COLOR: '#FF6C21',
    },
    'Sexual': {
        NAME: 'Sexual',
        COLOR: '#E5374F',
    },
    'Age': {
        NAME: 'Age',
        COLOR: '#A45037',
    },
    'Evidence Obstruction': {
        NAME: 'Evidence Obstruction',
        COLOR: '#45C182',
    },
    'Meeting': {
        NAME: 'Meeting',
        COLOR: '#8654E2',
    },
    'Police': {
        NAME: 'Police',
        COLOR: '#6884D9',
    },
    'Picture': {
        NAME: 'Picture',
        COLOR: '#36AFEC',
    },
    'Violence': {
        NAME: 'Violence',
        COLOR: '#D83200',
    },
};

export const SIMILARITY_COLORS = [
    '#FFBC31',
    '#D43B29',
    '#1EB1FE',
    '#009E5D',
    '#9B7EEF',
    '#E97BA9',
    '#F39C6B',
    '#EC1A7F',
    '#C5E99B',
    '#7FDBDB',
    '#44AF69',
    '#DBC17F',
    '#CE8FFF',
    '#5B869F',
    '#DD6E4C',
    '#2117CD',
    '#98A886',
    '#CA884C',
    '#9ACAE7',
    '#EDAEF8',
    '#CEE34D',
    '#BF98A0',
    '#90E39A',
    '#FFC99C',
];
